import { apiCall } from "../../../services/api-service";

export const getVehicleDetailAPI = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const getFuelHistDetAPI = (id) =>
  apiCall("get", `fuel_history/${id}`);

export const getFuelHistoryAPI = (id) =>
  apiCall("get", `fuel_history/${id}`);

export const submitAPI = (body) =>
  apiCall("post", "fuel_history", body);

export const addAttachmentApi = (id, body) =>
  apiCall("put", `fuel_history/add_attachment/${id}`, body);

export const UpdateAPI = (body, id) =>
  apiCall("put", `fuel_history/${id}`, body);
